<div class="col-xs-12" [ngClass]="{ tiny: tiny }">
  <button
    class="btn-primary"
    [ngClass]="{ 'has-icon': !tiny }"
    (click)="centralize()"
    type="button"
  >
    <i *ngIf="useIcon" class="far fa-eye"></i>
    <ng-container *ngIf="!tiny">{{ buttonText }}</ng-container>
  </button>
</div>
